import { Unit_instance3kz1zqli6gr1r as Unit_instance } from './Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from './Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from './hacks.mjs';
import { toString30pk9tzaqopn as toString } from './Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  LazyThreadSafetyMode_SYNCHRONIZED_instance = new (LazyThreadSafetyMode())('SYNCHRONIZED', 0);
  LazyThreadSafetyMode_PUBLICATION_instance = new (LazyThreadSafetyMode())('PUBLICATION', 1);
  LazyThreadSafetyMode_NONE_instance = new (LazyThreadSafetyMode())('NONE', 2);
}
var LazyThreadSafetyMode_SYNCHRONIZED_instance;
var LazyThreadSafetyMode_PUBLICATION_instance;
var LazyThreadSafetyMode_NONE_instance;
var LazyThreadSafetyModeClass;
function LazyThreadSafetyMode() {
  if (LazyThreadSafetyModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'LazyThreadSafetyMode');
    LazyThreadSafetyModeClass = $;
  }
  return LazyThreadSafetyModeClass;
}
var UnsafeLazyImplClass;
function UnsafeLazyImpl() {
  if (UnsafeLazyImplClass === VOID) {
    class $ {
      constructor(initializer) {
        this.au_1 = initializer;
        this.bu_1 = UNINITIALIZED_VALUE_instance;
      }
      n3() {
        if (this.bu_1 === UNINITIALIZED_VALUE_instance) {
          this.bu_1 = ensureNotNull(this.au_1)();
          this.au_1 = null;
        }
        return this.bu_1;
      }
      cu() {
        return !(this.bu_1 === UNINITIALIZED_VALUE_instance);
      }
      toString() {
        return this.cu() ? toString(this.n3()) : 'Lazy value not initialized yet.';
      }
    }
    initMetadataForClass($, 'UnsafeLazyImpl');
    UnsafeLazyImplClass = $;
  }
  return UnsafeLazyImplClass;
}
var UNINITIALIZED_VALUEClass;
function UNINITIALIZED_VALUE() {
  if (UNINITIALIZED_VALUEClass === VOID) {
    class $ {}
    initMetadataForObject($, 'UNINITIALIZED_VALUE');
    UNINITIALIZED_VALUEClass = $;
  }
  return UNINITIALIZED_VALUEClass;
}
var UNINITIALIZED_VALUE_instance;
function UNINITIALIZED_VALUE_getInstance() {
  return UNINITIALIZED_VALUE_instance;
}
function LazyThreadSafetyMode_PUBLICATION_getInstance() {
  static_init();
  return LazyThreadSafetyMode_PUBLICATION_instance;
}
function LazyThreadSafetyMode_NONE_getInstance() {
  static_init();
  return LazyThreadSafetyMode_NONE_instance;
}
//region block: init
UNINITIALIZED_VALUE_instance = new (UNINITIALIZED_VALUE())();
//endregion
//region block: exports
export {
  LazyThreadSafetyMode_NONE_getInstance as LazyThreadSafetyMode_NONE_getInstance29obelyddqkpt,
  LazyThreadSafetyMode_PUBLICATION_getInstance as LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67,
  UnsafeLazyImpl as UnsafeLazyImplgpp92xc41v15,
};
//endregion

//# sourceMappingURL=Lazy.mjs.map
